class common{
    getCharacterLength(str,length){
        let w = 0;
        let content = "";
        for(let i = 0;str[i]!=undefined;i++){
            if(/[\u4E00-\u9FA5\uF900-\uFA2D]/.test(str[i])){
                w += 2;
                if(w <= length)content += str[i];
            }else{
                w += 1;
                if(w <= length)content += str[i];
            }
        }
        return {
            length:w,
            content
        };
    }
    treeAnalysis(data,logic,tier,name,data1,n){
        if(tier > 0){   //判断层级
            if(n != undefined){ //判断是否是首次
                for(let i = 0;data[i]!=undefined;i++){
                    data1.push(data[i]);
                }
                tier--;
                this.treeAnalysis(data,logic,tier,name,data1);
            }else{
                for(let i = 0;data[i]!=undefined;i++){
                    this.logic(data,logic,data[i],name);
                    tier--;
                    this.treeAnalysis(data,logic,tier,name,data1);
                }
            }
        }
        if(tier == 0){  //到了最后一层
            for(let i = 0;data1[i]!=undefined;i++){
                if(data[i].pid == undefined && logic.emptyValue == undefined){
                }else if(data1[i].pid != logic.emptyValue && logic.emptyValue != undefined){
                    data1.splice(i,1);
                    i--;
                }
            }
        }
        return data1;
    }
    logic(data,logic,data1,name){   //逻辑判断
        for(let j = 0;data[j]!=undefined;j++){
            if(data[j][logic.id] == data1[logic.pid]){
                let children = name == undefined?"children":name; 
                data[j][children] = data[j][children] == undefined?[]:data[j][children];
                data[j][children].push(data1);
            }
        }
    }
    positionX(x,y,max){    //获取抛物线的x坐标
        for(y;y<=max;y++){
            
        }
    }
}
export default new common();



// WEBPACK FOOTER //
// ./src/assets/js/common.js